module.exports = __webpack_public_path__ + "media/images/web/home/index/theatre-daaed3d6d99af7f460280512ef8ab9e2.webp";